import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PublicBoxCosmetic } from '../../models/public-box-cosmetic';
import { PublicBoxCosmeticTileComponent } from '../../components/public-box-cosmetic-tile/public-box-cosmetic-tile.component';

@Component({
  selector: 'app-public-box-contents',
  imports: [CommonModule, PublicBoxCosmeticTileComponent],
  templateUrl: './public-box-contents.component.html',
  styleUrl: './public-box-contents.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PublicBoxContentsComponent {
  public readonly cosmetics = input.required<PublicBoxCosmetic[]>();
}
